export enum GetSubjectNotes {
  Request = 'GET_SUBJECT_NOTES_REQUEST',
  Success = 'GET_SUBJECT_NOTES_SUCCESS',
  Failed = 'GET_SUBJECT_NOTES_FAILED',
}

export enum GetNote {
  Request = 'GET_NOTE_REQUEST',
  Success = 'GET_NOTE_SUCCESS',
  Failed = 'GET_NOTE_FAILED',
}

export enum AddNote {
  Request = 'ADD_NOTE_REQUEST',
  Success = 'ADD_NOTE_SUCCESS',
  Failed = 'ADD_NOTE_FAILED',
}

export enum UpdateNote {
  Request = 'UPDATE_NOTE_REQUEST',
  Success = 'UPDATE_NOTE_SUCCESS',
  Failed = 'UPDATE_NOTE_FAILED',
}

export enum DeleteNote {
  Request = 'DELETE_NOTE_REQUEST',
  Success = 'DELETE_NOTE_SUCCESS',
  Failed = 'DELETE_NOTE_FAILED',
}
